









































































































import myTextArea from './components/myTextArea.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { requireGet, requirePost } from '../require'
@Component({
  components: {
    myTextArea,
  },
  filters: {
    regionConverter: region => {
      let province = region.province && region.province.region_name
      if (!province) {
        return ''
      }
      let city = region.city && region.city.region_name
      let district = (region.district && region.district.region_name) || ''
      return province + city + district
    },
  },
})
export default class ModifyAddress extends Vue {
  mode: any = 'create'
  is_default: any = false
  defaultOptions: any = [
    {
      label: '设置为默认地址',
      value: true,
    },
  ]

  address: any = {
    id: 0,
    name: '',
    phone: '',
    address: '',
    province: null,
    city: null,
    district: null,
  }
  showAddressPopup: boolean = false
  provincesSlot: any = [
    {
      values: [],
      textAlign: 'center',
      defaultIndex: 0,
    },
  ]
  citySlot: any = [
    {
      values: [],
      textAlign: 'center',
      defaultIndex: 0,
    },
  ]
  districtSlot: any = [
    {
      values: [],
      textAlign: 'center',
      defaultIndex: 0,
    },
  ]
  allAddress: any = {} // 用户确认的地址库
  currentAllAddress: any = {} // 用户滑动实时更新的地址库
  async mounted() {
    this.mode = this.$route.query.mode
    if (this.mode === 'create') {
      let { data } = await requireGet(`/api/mobile/course/yaya/getRegion`)
      this.allAddress = this.currentAllAddress = data
      this.setP(data)
      this.setC(data)
      this.setD(data)
      return
    }
    // modify
    this.loadReceiver(this.$route.query.id)
  }
  async loadReceiver(id) {
    let { data } = await requirePost(
      `/api/mobile/course/yaya/getUserReceiver`,
      {
        id,
      }
    )
    if (!data || !data.length) {
      return
    }
    this.address.id = data[0].id
    this.address.name = data[0].name
    this.address.phone = data[0].phone
    this.address.address = data[0].address
    this.is_default = data[0].is_default
    let r = await requireGet(
      `/api/mobile/course/yaya/getRegion?id=${data[0].province_id}`
    )
    this.allAddress = this.currentAllAddress = r.data
    this.loadPCD(
      data[0].province_id,
      data[0].city_id,
      data[0].district_id,
      true
    )
  }
  async loadPCD(provinceId, cityId, districtId, init = false) {
    const pIndex = this.find(this.currentAllAddress.provinces, provinceId)
    this.setP(this.currentAllAddress, this.currentAllAddress.provinces[pIndex])
    init && (this.address.province = this.currentAllAddress.provinces[pIndex])

    await Vue.nextTick()
    const cIndex = this.find(this.currentAllAddress.province.cities, cityId)
    this.setC(
      this.currentAllAddress,
      this.currentAllAddress.province.cities[cIndex]
    )
    init && (this.address.city = this.currentAllAddress.province.cities[cIndex])
    if (this.currentAllAddress.province.cities[cIndex].districts) {
      const dIndex = this.find(
        this.currentAllAddress.province.cities[cIndex].districts,
        districtId
      )
      this.setD(
        this.currentAllAddress,
        this.currentAllAddress.province.cities[cIndex].districts[dIndex],
        cIndex
      )
      init &&
        (this.address.district = this.currentAllAddress.province.cities[
          cIndex
        ].districts[dIndex])
    }
  }
  async onSaveAddress() {
    if (!this.address.name) {
      return this.$Toast('请输入姓名')
    } else if (!this.address.phone) {
      return this.$Toast('请输入手机号')
    } else if (isNaN(+this.address.phone)) {
      return this.$Toast('手机号不是纯数字')
    } else if (!this.address.province || !this.address.city) {
      return this.$Toast('请选择地址')
    } else if (!this.address.address) {
      return this.$Toast('请输入详细地址')
    }
    // store.receiveInfo = this.address
    let resp = await requirePost(`/api/mobile/course/yaya/saveUserReceiver`, {
      id: this.address.id,
      name: this.address.name,
      phone: this.address.phone,
      address: this.address.address,
      is_default: Number(this.is_default),
      province_id: this.address.province.id,
      province_name: this.address.province.region_name,
      city_id: this.address.city.id,
      city_name: this.address.city.region_name,
      district_id: this.address.district && this.address.district.id,
      district_name:
        (this.address.district && this.address.district.region_name) || '',
    })
    if ((resp as any).code) {
      return this.$Toast(`保存失败！${(resp as any).message}`)
    }
    this.back()
  }
  find(arr, id) {
    return arr.findIndex(item => {
      return item.id === id
    })
  }
  back() {
    this.$router.go(-1)
  }
  addressConfirm() {
    this.address.province = (this.$refs.pickerProvinces as any).getValues()[0]
    this.address.city = (this.$refs.pickerCities as any).getValues()[0]
    this.address.district = (this.$refs.pickerDistricts as any).getValues()[0]
    this.showAddressPopup = false
    this.allAddress = this.currentAllAddress
  }
  provinceChange(picker, values) {
    let slotValue = picker.getSlotValues(0)
    if (!values || !values.length || !slotValue) return
    let index = slotValue.indexOf(values[0])
    let id = this.currentAllAddress.provinces[index].id
    this.showAddressPopup && this.getRegion(id)
  }
  cityChange(picker, values) {
    let slotValue = picker.getSlotValues(0)
    if (!values || !values.length || !slotValue) return
    let index = slotValue.indexOf(values[0])
    this.showAddressPopup && this.setD(this.currentAllAddress, null, index)
  }
  async setP(arr, p = null) {
    let province: any = this.$refs.pickerProvinces
    province.setSlotValues(0, arr.provinces)
    province.setSlotValue(0, p || arr.provinces[0])
  }
  async setC(arr, c = null) {
    let city: any = this.$refs.pickerCities
    city.setSlotValues(0, arr.province.cities)
    city.setSlotValue(0, c || arr.province.cities[0])
  }
  async setD(arr, d = null, cityIndex = 0) {
    let ds = (arr.province.cities &&
      arr.province.cities[cityIndex].districts) || ['无']
    let district: any = this.$refs.pickerDistricts
    district.setSlotValues(0, ds)
    district.setSlotValue(0, d || ds[0])
  }
  async openAddressPicker() {
    this.currentAllAddress = this.allAddress
    this.address.province &&
      this.loadPCD(
        this.address.province.id,
        this.address.city.id,
        this.address.district && this.address.district.id
      )
    //   要await两次
    await Vue.nextTick()
    await Vue.nextTick()
    this.showAddressPopup = true
  }
  async getRegion(id = 2) {
    let { data } = await requireGet(
      `/api/mobile/course/yaya/getRegion?id=${id}`
    )
    this.currentAllAddress = data // address变了吗
    this.setC(data)
    // this.setD(data)
  }
}
